import React from 'react'
import PropTypes from 'prop-types'
import FormHOC from './FormHOC'
import Button from '../elements/Button'
import CustomLink from '../components/CustomLink'
import InputRow from '../elements/InputRow'

const Success = (
    <div className='text-center'>
        <p>Success! Your password has been reset and you may now log in by clicking on the link below.</p>
        <CustomLink to='/login' className='btn btn-custom'>Back to Login</CustomLink>
    </div>
)

const options = {
    postUrl: '/api/auth/postResetPasswordForm',
    success: Success
}

const state = {}

class ResetPasswordForm extends React.Component {
    componentDidMount () {
        this.props.setDynamicValues({
            token: this.props.token,
            login_name: this.props.loginName
        })
    }

    render () {
        return (
            <form onSubmit={this.props.handleSubmit} onKeyDown={this.props.handleKeyDown}>
                <InputRow
                    label='Choose a new password'
                    placeholder='Choose a new password'
                    name='password'
                    value={this.props.values.password}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                    type='password'
                />

                <InputRow
                    label='Confirm password'
                    placeholder='Confirm password'
                    name='password_confirmation'
                    value={this.props.values.password_confirmation}
                    errors={this.props.errors}
                    handleChange={this.props.handleInputChange}
                    type='password'
                />

                <div className='mb-2 mx-4 mx-lg-0 font-xsmall'>Your new password must be between 8-20 characters, contain at least one upper case, one lower case letter and one numeric digit</div>

                {this.props.children}

                <div className='mt-5'>
                    <Button title='Reset Password' action={this.props.handleSubmit} />
                </div>
            </form>
        )
    }
}

ResetPasswordForm.propTypes = {
    loginName: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
}

export default FormHOC(ResetPasswordForm, state, options)



// WEBPACK FOOTER //
// ./resources/js/forms/ResetPasswordForm.js